export const removeAllTrailingSlashes = (url: string): string => {
	return url.replace(/\/+$/, '');
};
